var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A) Icons / Navigation / Home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A)-Icons-/-Navigation-/-Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5090941,9.72189375 L13.0084537,2.90290875 C12.437362,2.37997519 11.5613774,2.3800346 10.9903566,2.90304563 L3.49099687,9.72184781 C3.17858783,10.0063426 3.00036865,10.4092051 2.99989938,10.8317409 L2.99989938,19.4656678 C2.99569862,19.842633 3.12943413,20.2081524 3.37599937,20.4933309 C3.66018079,20.8163536 4.06995324,21.001003 4.5001875,21.0000292 L8.99670375,21.0000292 C9.41091731,21.0000292 9.74670375,20.6641198 9.74670375,20.2499063 L9.74670375,15.7492219 C9.74670375,15.3350083 10.0824902,14.9992219 10.4967037,14.9992219 L13.4967037,14.9992219 C13.9109173,14.9992219 14.2467037,15.3350083 14.2467037,15.7492219 L14.2467037,20.2499063 C14.2467037,20.6641198 14.5824902,21.0000292 14.9967037,21.0000292 L19.5020766,21.0000292 C19.7485037,21.0031208 19.9916547,20.9432263 20.2083947,20.8259213 C20.695759,20.5628339 20.9996744,20.0537463 21,19.4999063 L21,10.8317813 C20.9995997,10.4092727 20.8214237,10.0064352 20.5090941,9.72189375 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.2ec93aeb.svg";
export { ForwardRef as ReactComponent };